import styled from 'styled-components';

export const Container = styled.section`
  border-radius: 5px;
  background: ${(props) => props.theme.colors.background};
  width: 100%;
  @media (max-width: 768px) {
    border-radius: 0px;
  }
  row-gap: 27px;
  column-gap: 8px;
  display: flex;
  flex-wrap: wrap;
  > button {
    text-transform: uppercase;
  }

  @media (max-width: 768px) {
    border-radius: 0px;
    row-gap: 24px;
    column-gap: 8px;
  }
`;
